export const enum QUESTIONS_IDS {
    PRIMARY_GOAL = "primary_goal",
    BIGGEST_DRIVE = "biggest_drive",
    FITNESS_EXPERIENCE = "fitness_experience",
    OBSTACLES = "obstacles",
    PROMO_HELP = "promo_help",
    PROMO_ZING_AI = "promo_zing_ai",
    PUSH_UPS = "push_ups",
    SQUATS = "squats",
    OTHER_SPORTS = "other_sports",
    EQUIPMENT_BY_ENVIRONMENT = "equipment_by_environment",
    TARGET_AREAS = "target_areas",
    LOCATION = "location",
    HEALTH_PROBLEMS = "health_problems",
    BODY_TYPE = "body_type",
    DESIRED_BODY = "desired_body",
    CURRENT_WEIGHT = "current_weight",
    BODY_FAT = "body_fat",
    EVENT_MOTIVATION = "event_motivation",
    TARGET_WEIGHT = "target_weight",
    DIET_TYPE = "nutrition_book_diet_type",
    ACTIVITY_LEVEL = "activity_level",
    SLEEP_AMOUNT = "sleep_amount",
    FITNESS_LEVEL = "fitness_level",
    TRAIN_3_MONTHS = "train_3months",
    ACTIVITY_ENGAGED = "activity_engaged",
    EATING_HABITS = "eating_habits",
    TRAINING_TRIGGER = "training_trigger",
    AGE = "age",
    AGE_GROUP = "age_group",
    HEIGHT = "height",
    EVENT_DATE = "event_date",
    GYM_TYPE = "gym_type",
    UNITS = "units",
    WATER_CONSUMPTION = "water_consumption",
    BMI_RESULTS = "bmi_results",
    FEEL_BETWEEN_MEALS = "feel_between_meals",
    SUCCESS_MEASURE = "success_measure",
    TRACK_STRENGTH = "track_strength",
    HOPE_TO_FEEL = "hope_to_feel",
    IMPORTANT_ELEMENTS = "important_elements",
    PROTECT_AGAINST_AGING = "protect_against_aging",
    SPORT_PREFER = "sport_prefer",
    DESIRED_WORKOUT_TIME = "desired_workout_time",
    CORTISOL = "level_of_cortisol_&_testosterone",
    WEIGHT_DEAD_LIFT = "weight_dead_lift",
    WEIGHT_BENCH_PRESS = "weight_bench_press",
    MOTIVATION = "motivation",
    PREVENT_EXERCISE_CONSISTENTLY = "prevent_exercise_consistently",
    ABILITY_TO_STAY_MOTIVATED = "ability_to_stay_motivated",
    ACHIEVE_FITNESS_GOAL = "achieve_fitness_goal",
    MOTIVATE_MOST = "motivate_most",
    COPE_STRESS = "cope_stress",
    DAILY_WALK = "daily_walk",
    PLAN_FAILED = "plans_failed",
    STATEMENT_REQUIRE_GUIDANCE = "statement_require_guidance",
    STATEMENT_SUPPORT_BOOSTS_MOTIVATION = "statement_support_boosts_motivation",
    WEIGHT_LOSS_GOAL = "weight_loss_goal",
    PACE = "pace",
    PROMO_SOCIAL_PROOF = "promo_social_proof",
    BREATH_LOSE = "breath_lose",
    ADD_CARDIO_TO_PLAN = "add_cardio_to_plan",
    SELECT_CARDIO_MACHINES = "select_cardio_machines",
    // Weight Predict
    INITIAL_WEIGHT_PREDICT = "initial_weight_predict",
    FIRST_WEIGHT_PREDICT_DATE = "first_weight_predict_date",
    WEIGHT_PREDICT_DATE = "weight_predict_date",
    INTERMEDIATE_WEIGHT_LOSS = "intermediate_weight_loss",
    INTERMEDIATE_WEIGHT_LOSS_DATE = "intermediate_weight_loss_date",
    SHOW_INTERMEDIATE_RESULT = "show_intermediate_result",
    // Seniors Funnel
    TRIED_INDOOR_WORKOUT = "tried_indoor_workout",
    YOU_WILL_DO_FANTASTIC = "you_will_do_fantastic",
    WE_GOT_THE_SOLUTION = "we_got_the_solution",
    WEIGHT_TYPICAL_CHANGE = "weight_typical_change",
    BEST_SHAPE_OF_YOUR_LIFE = "best_shape_of_your_life",
    WALK_FREQUENCY = "walk_frequency",
    WORK_SCHEDULE = "work_schedule",
    ENERGY_LEVEL = "energy_level",
    ENERGY_INCREASE = "energy_increase",
    BAD_HABITS = "bad_habits",
    FOOD_CRAVINGS = "food_craving",
    WEIGHT_GAIN_EVENTS = "weight_gain_events",
    MAIN_REASON_TO_GET_IN_SHAPE = "main_reason_to_get_in_shape",
    CONFIDENCE_ABOUT_PREDICT = "confidence_about_predict",
    // Calisthenics
    CALISTHENICS_GOAL_FEEDBACK = "calisthenics_goal_feedback",
    CALISTHENICS_OBSTACLE_FEEDBACK = "calisthenics_obstacle_feedback",
    CALISTHENICS_RESTRICTIONS_FEEDBACK = "calisthenics_restrictions_feedback",
    CALISTHENICS_LEVEL_FEEDBACK = "calisthenics_level_feedback",
    CALISTHENICS_TRAINING_FREQUENCY_FEEDBACK = "calisthenics_training_frequency_feedback",
    FAMILIAR_CALISTHENICS = "familiar_calisthenics",
    // New Qs sequence
    UNHAPPY_ABOUT_YOUR_CURRENT_FITNESS = "unhappy_about_your_current_fitness",
    DRIVES_TO_ACHIEVE_GOALS = "drives_to_achieve_goals",
    HOLDING_BACK_FROM_FITNESS_GOALS = "holding_back_from_fitness_goals",
    STATEMENT_TIRED_OF_GUESSING = "statement_tired_of_guessing",
    YOU_ARE_ON_THE_RIGHT_TRACK = "you_are_on_the_right_track",
    ACTIVE_USERS_AND_REVIEWS = "active_users_and_reviews",
    FITNESS_TRACKER_DEVICE = "fitness_tracker_device",
    // Pilates
    TRIED_WALL_PILATES = "tried_wall_pilates",
    DISCOVER_ZING_WALL_PILATES = "discover_zing_wall_pilates",
    PILATES_MAKES_YOU_MORE_ENERGIZED = "pilates_makes_you_more_energized",
    STRETCHING_EXERCISE = "stretching_exercise",
    FORWARD_LUNGE_EXERCISE = "forward_lunge_exercise",
    WALL_SIT_EXERCISE = "wall_sit_exercise",
    WALL_LUNGE_STRENGTH_EXERCISE = "wall_lunge_stretch_exercise",
    WHY_PEOPLE_GIVE_UP = "why_people_give_up",
    // Upgrade Funnel
    FEEL_ABOUT_AI = "feel_about_ai",
    TYPICAL_DAY = "typical_day",
    WORKOUT_FREQUENCY = "workout_frequency",
    FALL_BACK_TO_ROUTINE = "fall_back_to_routine",
    GIVE_UP_WHEN_HARD = "give_up_when_hard",
    UNSURE_SUITABLE_WORKOUTS = "unsure_suitable_workouts",
    DISSATISFIED_WITH_BODY = "dissatisfied_with_body",
    PROMO_ELIGIBLE_ZING_USER = "promo_eligible_zing_user",
    DESIRED_WORKOUT_FREQUENCY = "desired_workout_frequency",
    DESIRED_WORKOUT_DURATION = "desired_workout_duration",
    SLEEP_QUALITY = "sleep_quality",
    SENSITIVE_AREAS_FEEDBACK = "sensitive_areas_feedback",
    DEVICE_FEEDBACK = "device_feedback",
    PACE_FEEDBACK = "pace_feedback",
    ENERGY_FEEDBACK = "energy_feedback",
    NUTRITION_FEEDBACK = "nutrition_feedback",
    BUILT_FOR_WOMEN_NOT_GENERIC_PLANS = "built_for_women_not_generic_plans",
    PROMO_SMART_FITNESS = "promo_smart_fitness",
    UNLOCK_INNER_MOTIVATION = "unlock_inner_motivation",
    ACTIVE_USERS_PROMO = "active_users_promo",
    // Body Scan Funnel
    TRIED_AI_WORKOUTS = "tried_ai_workouts",
    DISCOVER_ZING_BODY_SCAN = "discover_zing_body_scan",
    ZING_CAN_MAKE_IT_HAPPEN = "zing_can_make_it_happen",
    WE_GOT_YOU = "we_got_you",
    ZING_COACH_HELP_YOU_FEEL_MORE_ENERGIZED = "zing_coach_help_you_feel_more_energized",
    SQUATS_EXERCISE = "squats_exercise",
    PLANK_EXERCISE = "plank_exercise",
    LIFTING_WEIGHTS_EXERCISE = "lifting_weights_exercise",
    // Weight Loss Funnel
    PERFECT_SOLUTION_STARTS_HERE = "perfect_solution_starts_here",
    NEVER_TOO_LATE_TO_GET_BACK_IN_SHAPE = "never_too_late_to_get_back_in_shape",
    BIGGEST_STRUGGLE = "biggest_struggle",
    LETS_DIVE_DEEPER = "lets_dive_deeper",
    DISCOVER_NUTRITION_BOOK = "discover_nutrition_book",
    ENJOY_WORKOUT_STYLES = "enjoy_workout_styles",
    PROGRESS_LOADER = "progress_loader",
    EMAIL = "email",
    NAME = "name",
    CHANGE_LIFE = "change_life",
    FIRST_THING_AFTER_GOAL = "first_thing_after_goal",
    THANKS_FOR_YOUR_HONESTY = "thanks_for_your_honesty",
    RESULT_IN_4_WEEKS = "result_in_4_weeks",
    PROMO_SOCIAL_PROOF_WEIGHT_LOSS = "promo_social_proof_weight_loss",
    WORKOUT_FEEL = "workout_feel",
    //reorder reaction screen
    GOAL_REACTION = "goal_reaction",
}

export const enum QuestionTypes {
    AIBodyScan = "AIBodyScan",
    YesNo = "yes/no",
    YesNoWithImage = "yesNoWithImage",
    YesNoWithImageUpgraded = "yesNoWithImageUpgraded",
    BmiPromoMale = "bmiPromoMale",
    BmiPromoFemale = "bmiPromoFemale",
    Radio = "radio",
    RadioCards = "radioCards",
    Checkbox = "checkbox",
    CheckboxInline = "checkbox_inline",
    CheckboxImageLeft = "checkbox_image_left",
    RadioImageLeft = "radio_image_left",
    PromoHelp = "promoHelp",
    PromoScreen = "promoScreen",
    Input = "input",
    Cortisol = "cortisol_screen",
    Range = "range",
    Date = "date",
    Rate = "rate",
    ReviewsPromo = "reviewsPromo",
    PromoZingAi = "promoZingAi",
    PromoSocialProof = "promoSocialProof",
    InitialWeightPredict = "initialWeightPredict",
    CurrencyInput = "currencyInput",
    CalisthenicsFeedbackLoops = "calisthenicsFeedbackLoops",
    ReviewWithLoader = "reviewWithLoader",
    ReviewAndActiveUsers = "reviewAndActiveUsers",
    LikeDislike = "likeDislike",
    PromoWithUserReview = "promoWithUserReview",
    PromoNewbies = "promoNewbies",
    PromoFitnessEnthusiasts = "promoFitnessEnthusiasts",
    PromoCoreReviews = "promoCoreReviews",
    MotivationalScreen = "motivationalScreen",
    PromoEligibleZingUser = "promoEligibleZingUser",
    PromoSmartFitness = "promoSmartFitness",
    PromoZingCanMakeIt = "promoZingCanMakeIt",
    ProgressLoader = "progressLoader",
    Email = "email",
    Name = "name",
}

export const enum CheckboxAnswersType {
    tiles = "tiles",
    bigTiles = "bigTiles",
    list = "list",
}

export const enum RadioAnswersType {
    tiles = "tiles",
    list = "list",
}
